<template>
  <div class="login">
    <!-- <h1>SERVIDOR DE TESTES
    </h1> -->
    <v-layout row justify-center>
      <v-flex xs12 sm6 md6 lg4>
        <v-card>
          <v-card-media :src="changeLogo()" :class="changeCssColor()" height="200px" contain>
          </v-card-media>
          <!-- <v-card-media class="backgroud-logo logo" height="200px">
          </v-card-media> -->
          <div class="backgroud-logo logo">
          </div>
          <v-card-title primary-title>
            <v-card-text>
              <v-form @keyup.enter.native="submit()" action="#" v-model="valid" ref="form" lazy-validation @submit.prevent="submit()">
                <v-text-field
                  label="E-Mail"
                  v-model="auth.user.username"
                  :rules="usernameRules"
                  required
                ></v-text-field>
                <v-text-field
                  name="input-10-1"
                  label="Entre com sua senha"
                  hint="Deve conter mais de 6 caracteres"
                  v-model="auth.user.password"
                  min="6"
                  :rules="passwordRules"
                  :append-icon="e1 ? 'visibility_off' : 'visibility'"
                  :append-icon-cb="() => (e1 = !e1)"
                  :type="e1 ? 'password' : 'text'"
                  counter
                ></v-text-field>

                <!-- <v-checkbox
                  color = 'primary'
                  label="Lembre-me"
                  v-model="checkbox"
                ></v-checkbox> -->
                <router-link to="/patient/forget-password">
                  <p class="text-xs-right title">Esqueceu sua senha?</p>
                </router-link>

                <v-btn
                  color = 'primary'
                  block
                  :disabled="!valid"
                  @click="submit()"
                >
                  Login
                </v-btn>
                <br><hr><br>
                <!-- <v-btn @click="clear">clear</v-btn> -->
                <router-link to="/patient/register">
                  <v-btn block>Cadastrar</v-btn>
                </router-link>
                <!-- <router-link to="/customer">
                  <v-btn @click="clear">Customer</v-btn>
                </router-link>   -->
              </v-form>

            </v-card-text>
          </v-card-title>
          <v-card-actions>
            <div>
              <p>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</p>
              <p>Versão: {{getPkg.pkg.version}}</p>
            </div>
            <!-- <v-btn flat color="orange">Share</v-btn>
            <v-btn flat color="orange">Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="snackbarConfig.timeout"
      :color="snackbarConfig.color"
      :multi-line="snackbarConfig.mode === 'multi-line'"
      :vertical="snackbarConfig.mode === 'vertical'"
      v-model="snackbarConfig.snackbar"
    >
      {{ snackbarConfig.text }}
      <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import axios from 'axios'
  import localforage from 'localforage'
  import { mapActions, mapGetters } from 'vuex'
  // import { url } from '../../../config/api.link.connection'
  import customersTheme from '../../../config/customersTheme'

  export default {
    name: 'Login',
    computed: {
      ...mapGetters({
        customer: 'customer'
      }),
      ...mapGetters('app', ['getTheme', 'getPkg'])
    },
    mounted () {
      this.$vuetify.theme.primary = this.getTheme.colorHTML // this.getTheme.color
      this.loadHealthInsurance()
    },
    data: () => ({
      env: process.env.URL,
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      usernameRules: [
        (v) => !!v || 'E-Mail obrigatório!'
      ],
      passwordRules: [
        (v) => !!v || 'Senha obrigatória!'
      ],
      valid: true,
      e1: true,
      auth: {
        isLogged: false,
        token: '',
        user: {
          username: '',
          password: '',
          id: '',
          client: '',
          name: ''
        }
      },
      checkbox: false
    }),
    methods: {
      loadHealthInsurance () {
        this.$http.get(`${process.env.URL}/schedule-online/health-insurance`, {
          params: {
            customer: this.customer
          }
        }).then(() => {
          this.valid = true
        }).catch((err) => {
          this.snackbarConfig.snackbar = true
          // this.snackbarConfig.color = 'alert'
          this.snackbarConfig.text = 'Servidor da clinica não esta ativo!'
          this.valid = false
          console.log(err)
        })
      },
      changeCssColor () {
        const customerTheme = customersTheme[localStorage.getItem('riscSchedulePatientCustomer')]
        // console.log(customerTheme.cssClass)
        return customerTheme.cssClass
      },
      changeLogo () {
        const customerTheme = customersTheme[localStorage.getItem('riscSchedulePatientCustomer')]
        return customerTheme.logo
      },
      changeColorHTML () {
        const customerTheme = customersTheme[localStorage.getItem('riscSchedulePatientCustomer')]
        return customerTheme.colorHTML
      },
      ...mapActions(['setUser']),
      submit () {
        if (this.$refs.form.validate()) {
          axios.post(process.env.URL + '/schedule-online/auth/patient/login', {
            username: this.auth.user.username,
            password: this.auth.user.password
          }, {
            params: {
              customer: this.customer
            }
          }).then((response) => {
            // if (this.checkbox) {
            //   localStorage.setItem('token', response.data.result.token)
            // }
            const auth = {
              isLogged: true,
              token: response.data.result.token,
              user: {
                username: this.auth.user.username,
                id: response.data.result.user._id,
                customer: response.data.result.user.customer,
                name: response.data.result.user.name,
                healthInsurance: parseInt(response.data.result.user.healthInsurance),
                numberMedicalRecord: parseInt(response.data.result.user.numberMedicalRecord),
                profile: response.data.result.user.profile,
                // client: response.data.result.result[0].scheduleOnline.client[0],
                clientId: response.data.result.user._id
              }
            }
            this.setUser(auth)
            if (this.checkbox) {
              localforage.setItem('token', response.data.result.token).then((value) => {
                // console.log(value)
              })
              localforage.setItem('user', auth).then((value) => {
                // console.log(value)
              })
            }
            this.$router.push('/')
          }).catch((err) => {
            if (err.response.data.message) {
              this.snackbarConfig.snackbar = true
              this.snackbarConfig.text = err.response.data.message
              return false
            }
            if (err.response.data.errors) {
              if (err.response.data.errors.username) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.msg
                return false
              }
              if (err.response.data.errors.password) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.password.msg
                return false
              }
            }
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>

<style scoped>
  /* .login {margin-top: 20px;} */
  .logo {
    background-image: url("https://storage.googleapis.com/spitzer-risc-logos/logo-ipo.png");
  }
</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue